var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v2H0zM7 9h13v2H7zM0 17h20v2H0z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTkiIGZpbGw9Im5vbmUiPgogIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTAgMEgyMFYySDB6Ii8+CiAgPHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNNyA5SDIwVjExSDd6Ii8+CiAgPHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNMCAxN0gyMFYxOUgweiIvPgo8L3N2Zz4=";
export { SvgSubmenu as ReactComponent };